import { Box } from "@mui/material";
import Slider from "react-slick";
import "./styles.css";

interface ImageSliderProps {
  imageUrls: string[];
}

const ImageSlider = (props: ImageSliderProps) => {
  const { imageUrls } = props;

  const settings = {
    accessibility: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 3500,
    lazyLoad: "ondemand",
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {imageUrls.map((image, index) => (
        <img src={image} alt={`Image ${index}`} key={index} loading="lazy" className="outdoor-slot"/>
      ))}
    </Slider>
  );
};

export default ImageSlider;
